/**
 * How a bot and its owner are named across the admin Stars screens.
 *
 * Shared rather than copied: the Stars permission list and the settlement
 * report name the same bots, and two copies of "how a bot is written" would
 * drift into two different names for one partner on two screens.
 */

/** How a bot is named on screen: the username if we have one, else its id. */
export const botLabel = (bot: {
  bot_username?: string | null;
  bot_id?: number | null;
}): string => {
  if (bot.bot_username) return `@${bot.bot_username}`;
  if (bot.bot_id !== null && bot.bot_id !== undefined) return `bot ${bot.bot_id}`;
  return 'unnamed bot';
};

/**
 * The owner is the person who receives the Stars, so "unknown" must read as a
 * gap in what we know — never as an absent owner, and never as nothing at all.
 */
export const ownerLabel = (userId: number | null | undefined): string =>
  userId === null || userId === undefined ? 'unknown' : `user #${userId}`;
